<template>
  <div>
    <recharge-manual-ledger-list :record-only="true" />
  </div>
</template>

<script>
import rechargeManualLedgerList from '@/views/finance/rechargeManualLedgerAudit/list.vue'

export default {
  components: {
    rechargeManualLedgerList
  }
}
</script>
